<template>
    <div>
        <b-form-group
            label="ID Document Type"
            label-for="documentType"
            class="required-field"
        >
            <b-form-select
                v-model="model"
                v-validate="{
                    required: true,
                }"
                class="form-control"
                :options="options"
                :disabled="loading || disabled"
                data-vv-name="document type"
                :class="{
                    'is-invalid': errors.has('document type'),
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>
<script>
import Dropdown from './Dropdown.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    title: 'Select ID Document Type',
                    label: 'ID Document Type',
                    placeholder: 'Select ID Document Type',
                    options: [
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                        {
                            text: 'Driving Licence',
                            value: 'licence',
                        },
                        {
                            text: 'Passport',
                            value: 'passport',
                        },
                    ],
                    key: 'identityInfo.type',
                }
            },
            required: false,
        },
        dataSegmentId: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            this.$store.commit('updateField', {
                key: 'documentInfo.identity',
                value: {
                    originalFileName: null,
                    fileName: null,
                },
            })
        },
    }, // End of Component > props
    
    // mounted(){
    //     if(this.field.key == "identityInfo.type"){
    //         this.$store.commit('updateField', {
    //                 key: this.field.key,
    //                 value: "id",
    //             })
    //     }
    // },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.options = this.field.options
    }, // End of Component > watch
}
</script>
